import { StringHelper } from "../../../../utilities/contracts/string-helper";
import { MeasureDosDateRange } from "./measure-dos-date-range.model";

export class ChartLakeInputData {
  projectId?: number;
  projectName?: string;
  dosStartDate?: string;
  dosEndDate?: string;
  includeWithoutDos?: boolean;
  measureDosDateRanges?: MeasureDosDateRange[];

  constructor(options: Partial<ChartLakeInputData> = {}) {
    this.projectId = options.projectId;
    this.projectName = StringHelper.clean(options.projectName);
    this.dosStartDate = StringHelper.clean(options.dosStartDate);
    this.dosEndDate = StringHelper.clean(options.dosEndDate);
    this.includeWithoutDos = options.includeWithoutDos;
    this.measureDosDateRanges = (options.measureDosDateRanges || []).map(m => new MeasureDosDateRange(m));
  }
}
